import React, {useEffect, useState} from 'react';
import {useDispatch, useSelector} from 'react-redux';

import {makeStyles} from '@material-ui/core/styles';

import {getNewPolls, getPassedPolls, pollSelector, getEducationList} from '../../redux/polls'
//import {Typography, Card, CardHeader, CardActions, Button, Collapse, IconButton} from '@material-ui/core';
import {
  Accordion,
  AccordionSummary,
  AccordionDetails,
  AccordionActions,
  Typography,
  Divider,
  Button,
} from '@material-ui/core'
import ExpandMoreIcon from "@material-ui/icons/ExpandMore";

import {dateTimeToStr} from '../../utils/utils';
import {confirm} from "../../redux/confirm";
import {history} from '../../App';
import {POLL_PAGE} from '../../constants/app-constants';
import {useRouteMatch} from "react-router-dom";
import AskPollEducation from './AskPollEducation';

const useStyles = makeStyles((theme) => {
    console.log(theme);
    return ({
      accordion: {
        boxShadow: theme.shadows[3]
      },
      header: {},
      subheader: {
        color: theme.palette.info.dark,
        fontStyle: 'italic'
      },
      summary: {},
      actions: {
        justifyContent: 'flex-start'
      },
      section: {
        maxHeight: '50vh',
        overflowY: 'auto',
        padding: '5px'
      },
      section1: {
        overflowY: 'auto',
        padding: '5px'
      },
      divider: {
        paddingBottom: '2px',
        marginBottom: '1em'
      }
    })
  }
);


export default function PollLandingPage(props) {

  const dispatch = useDispatch();
  const classes = useStyles();

  const {newPolls, passedPolls} = useSelector(pollSelector);
  const [openDlg, toggleOpenDlg] = useState(false);
  const [educationList, setEducationList] = useState([]);
  const [pollId, setPollId] = useState();

  useEffect(() => {
    dispatch(getNewPolls());
    dispatch(getPassedPolls());
  }, []);

  let {path} = useRouteMatch();

  const handleStartPoll = async (pollId) => {
    await dispatch(confirm('Почати опитування?'));
    const educationList = await dispatch(getEducationList(pollId));
    if (educationList.length === 1) {
      history.push(`${path}${POLL_PAGE}/${pollId}?educationId=${educationList[0].educationId}&action=edit`);
    } else {
      setEducationList(educationList);
      setPollId(pollId);
      toggleOpenDlg(true);
    }
  };

  const handleViewPoll = (pollId, educationId) => history.push(`${path}${POLL_PAGE}/${pollId}?educationId=${educationId}&action=view`);

  const pollArr = newPolls.map((item, index) => {
    return <Accordion className={classes.accordion} key={index}>
      <AccordionSummary
        className={classes.summary}
        expandIcon={<ExpandMoreIcon/>}
        id={index}
      >
        <div>
          <Typography variant='subtitle1' className={classes.header}>{item.pollName}</Typography>
          <Typography variant='subtitle2' className={classes.subheader}>
            {`Кількість запитань: ${item.questionCount}. Опитування проводиться з ${dateTimeToStr(item.dateBegin)} по ${dateTimeToStr(item.dateEnd)}`}
          </Typography>
        </div>
      </AccordionSummary>
      <AccordionDetails>

        <Typography>
          {item.description}
        </Typography>
      </AccordionDetails>
      <AccordionActions className={classes.actions}>
        <Button variant="contained" color="primary" onClick={() => handleStartPoll(item.pollId)}>Пройти</Button>
      </AccordionActions>
    </Accordion>
  });


  const passedPollArr = passedPolls.map((item, index) => {
    return <Accordion className={classes.accordion} key={index}>
      <AccordionSummary
        className={classes.summary}
        expandIcon={<ExpandMoreIcon/>}
        id={index}
      >
        <div>
          <Typography variant='subtitle1' className={classes.header}>{item.pollName}</Typography>
          <Typography variant='subtitle2' className={classes.subheader}>
            {`Пройдено: ${dateTimeToStr(item.passedDate)}. Параметри навчання: ${item.eduInfo || ''}`}
          </Typography>
        </div>
      </AccordionSummary>
      <AccordionDetails>
        <div>
          <Typography>
            {item.description}
          </Typography>
        </div>
      </AccordionDetails>
      <AccordionActions className={classes.actions}>
        <Button variant="contained" color="primary"
                onClick={() => handleViewPoll(item.pollId, item.educationId)}>Переглянути
          відповіді</Button>
      </AccordionActions>
    </Accordion>
  });

  return (
    <>
      <Typography variant='h5'>
        Нові опитування
      </Typography>
      <Divider className={classes.divider}/>
      <div className={classes.section}>
        {pollArr}
      </div>
      <Typography variant='h5' style={{paddingTop: '1em'}}>
        Пройдені опитування
      </Typography>
      <Divider className={classes.divider}/>
      <div className={classes.section1}>
        {passedPollArr}
      </div>
      <AskPollEducation open={openDlg} toggle={toggleOpenDlg} educationList={educationList} pollId={pollId}/>
    </>
  );
}

